<template>
  <div>
    <div class="container">
      <template v-for="notification in showData">
        <component :is="notification.component" :data="notification"/>
      </template>
    </div>
  </div>
</template>

<script>
// import io from 'socket.io-client';
import IncomePhoneCall from "@/components/notifications/templates/IncomePhoneCall";
import store from "@/store";
import {chatUpdated} from "@/eventsBus";
import api from '@/api'
import moment from "moment";
import services from '@/services/auth'
import CallBackRequestByRunner from "@/components/notifications/templates/CallBackRequestByRunner.vue";
import ClientCallBackSiteRequest from "@/components/notifications/templates/ClientCallBackSiteRequest.vue";

export default {
  components: {
    IncomePhoneCall,
    CallBackRequestByRunner,
    ClientCallBackSiteRequest,
  },
  data() {
    return {
      // socket: io(),
      showMessageType: {
        incomingPhoneCall: false,
      },
      componentsNames: {
        'incomingPhoneCall': IncomePhoneCall,
        'clientCallBackByRunner': CallBackRequestByRunner,
        'clientSiteCallBackRequest': ClientCallBackSiteRequest
      },
      showData: {}
    }
  },
  beforeDestroy() {
    // console.log('beforeDestroy');
    this.$socket.client.off('personal_user_' + this.$currentUID)
  },
  mounted() {
    console.log('subscribe', 'personal_user_' + this.$currentUID)
    this.$socket.client.on('personal_user_' + this.$currentUID, (payload) => {
      console.log(payload);
      this.showNotification(payload)
    })
    this.$socket.client.on('global_channel', (payload) => {
      // console.log('global_channel', payload);
      this.showNotification(payload)
    })
    this.getActiveNotificationFigures();
    // this.$socket.client.off('usersUpdate')
    // setTimeout(() => {
    //   this.showNotification({
    //     type: 'incomingPhoneCall',
    //     client: {
    //       name: 'Gomer'
    //     }
    //   })
    // }, 1000)
  },
  computed: {
    $ActiveWorkGroup() {
      return this.$store.getters["user/activeWorkGroup"];
    }
  },
  methods: {
    async showNotification(data) {
      // if (data.type !== 'setWorkingShift' && !this.$myShift) return;

      data.component = this.getComponentByType(data.type);
      switch (data.type) {
        case 'updateDynamicData':
          console.log(data);
          store.dispatch('platform/setDynamicData', data?.data ?? {});
          break;
        case 'clientCallBackByRunner':
          data.open = true;
          data.data = JSON.parse(data.data);
          const timeIndex = moment().toDate().getTime();
          setTimeout(() => {
            delete this.showData[timeIndex];
            this.showData = {...this.showData};
          }, 300000);
          this.showData[timeIndex] = data;
          this.showData = {...this.showData};
          this.sendSoundNotification();
          break;
        case 'updateOrderUnderManagerProgress':
          store.dispatch('orders/setNewOrdersUnderManagerProgress', JSON.parse(data.record));
          break;
        case 'newTask':
          this.Toast.fire({
            type: "info",
            title: 'новая задача',
            timer: 10000,
            animation: true,
            confirmButtonText: 'показать',
            showConfirmButton: true
          }).then(async (result) => {
            if (result.value) this.mixinGoToRouter('TasksList');
          });
          // store.dispatch('platform/setActiveNotifications', {...this.$ActiveNotifications, ...{bankSMS: data.totalIncomeSMS}});
          await this.sendSoundNotification();
          break;
        case 'newClientChatMessage':
          // console.log(data);
          // console.log(this.$can('clientsChats'));
          // console.log(this.$currentUserRoles.includes('clientChatManager'));
          if (!this.$can('clientsChats') || !this.$currentUserRoles.includes('clientChatManager')) return;
          let notice = this.$store.getters['platform/activeNotifications'];
          const totalChats = JSON.parse(data?.total_chats) || {};
          // console.log(this.$orderAccess?.all?.all,)
          if (this.$orderAccess?.all?.all) {
            notice.activeChatDialogs = Object.values(totalChats || {}).reduce((acc, v) => acc + v, 0);
          } else {
            notice.activeChatDialogs = Object.keys(this.$orderAccess || {}).reduce((acc, k) => acc + (totalChats[k] || 0), 0);
          }
          store.dispatch('platform/setActiveNotifications', notice);
          if (!this.$orderAccess.all?.all && !this.$orderAccess[data.project_id]) return;
          if (!data.chat_id) return;
          chatUpdated.$emit('updateChat', {chat_id: data.chat_id});
          if (this.$currentUserRoles.includes('clientChatManager')) {
            if (!(this.$userSettings?.webSettings?.showChatMessages ?? false)) return;
            if (this.$userSettings?.webSettings?.soundChatMessages) {
              await this.sendSoundNotification('newClientChatMessage');
            }
            this.Toast.fire({
              type: "info",
              title: 'новое сообщение с сайта',
              timer: 10000,
              animation: true,
              confirmButtonText: 'показать',
              showConfirmButton: true
            }).then(async (result) => {
              if (result.value) {
                this.mixinGoToRouter('ClientsChats', {chat_id: data.chat_id});
              }
            });
          }
          break;
        case 'globalNotificationsUpdate':
          let notifications = {...this.$ActiveNotifications};
          notifications = {...notifications, ...data.notifications}
          // console.log(notifications);
          store.dispatch('platform/setActiveNotifications', {...notifications});
          break;
        case 'updateBadgedsFigures':
          let totalFigures = {...this.$ActiveNotifications};
          if (data.totalIncomeSMS !== undefined) {
            totalFigures.bankSMS = data.totalIncomeSMS;
          }
          store.dispatch('platform/setActiveNotifications', totalFigures);
          break;
        case 'newSMS':
          this.Toast.fire({
            type: "info",
            title: 'новое SMS',
            timer: 10000,
            animation: true,
            confirmButtonText: 'показать',
            showConfirmButton: true
          }).then(async (result) => {
            // this.mixinGoToRouter('bankSMS');
          });
          store.dispatch('platform/setActiveNotifications', {...this.$ActiveNotifications, ...{bankSMS: data.totalIncomeSMS}});
          await this.sendSoundNotification();
          break;
        case 'updateActiveNotificationsFigures':
          store.dispatch('platform/setActiveNotifications', {...this.$ActiveNotifications, ...data.figures});
          break;
        case 'newOrder':
          if (!(this.$userSettings && this.$userSettings.webSettings && !!this.$userSettings.webSettings.newOrder)) return;
          this.Toast.fire({
            type: "info",
            title: 'Новая заявка с сайта',
            timer: 10000,
            animation: true,
            confirmButtonText: 'показать',
            showConfirmButton: true
          }).then(async (result) => {
            if (result.value) {
              this.$store.dispatch('orders/setOrderToEdit', {orderId: data.order_id})
              // this.mixinGoToRouter('ClientsChats', {chat_id: data.chat_id});
            }
          });
          await this.sendSoundNotification('newColdClient');
          break;
        case 'newColdClient':
          if (!(this.$userSettings && this.$userSettings.webSettings && !!this.$userSettings.webSettings.newOrder)) return;
          if (data.type === 'newColdClient') {
            toastr['info']('Новый холодный клиент', 'Внимание');
          } else {
            toastr['info']('Поступила новая заявка', 'Обновление');
          }
          await this.sendSoundNotification(data.type);
          break;
        case 'updateUserSettings':
          this.$store.dispatch('user/setUserSettings', {...this.$userSettings, ...data});
          break;
        case 'updateChat':
          chatUpdated.$emit('updateChat', data);
          break;
        case 'clientSiteCallBackRequest':
        case 'incomingPhoneCall':
          // console.log('in phone');
          if (!(this.$userSettings && this.$userSettings.webSettings && !!this.$userSettings.webSettings.incomeCalls)) {
            console.log('hide income call by user');
            return;
          }
          data.open = true;
          const index = moment().toDate().getTime();
          this.showData[index] = data;
          this.showData = {...this.showData};
          setTimeout(() => {
            delete this.showData[index];
            this.showData = {...this.showData};
          }, 45000)
          this.sendSoundNotification();
          break;
        case 'setWorkingShift':
        case 'closeWorkingShift':
          const newData = await services.check(false, true)
          if (newData?.user?.id) {
            await services.updateShiftUserData(newData)
            // await this.$store.dispatch('user/setActiveWorkGroup', data?.shift ?? null);
            await this.$store.dispatch('user/setMyShift', data?.shift ?? null);
          } else {
            toastr['warning'](data.message ?? 'Ошибка сервера', 'Ошибка!');
          }
          break;
        default:
          break;
      }
    },
    getComponentByType(type) {
      return this.componentsNames[type];
    },
    async sendSoundNotification(type = 'newOrder') {
      if (this.$userSettings && this.$userSettings.webSettings && !!this.$userSettings.webSettings.notificationSound) {
        let url = "https://admin.rancond.info/assets/audio/notifications/notification_call.mp3";
        switch (type) {
          case 'newClientChatMessage':
            url = "https://admin.rancond.info/assets/audio/notifications/new_chat_message.mp3";
            break;
          case 'newColdClient':
            url = "https://admin.rancond.info/assets/audio/notifications/new_site_order.mp3"
            break;
          default:
            break;
        }
        try {
          const audio = new Audio(url);
          // audio.muted = true;
          // const playPromise = audio.play();
          await audio.play();
        } catch (e) {
          console.log(e);
        }
      }
    },
    async getActiveNotificationFigures() {
      const {data} = await api.index('/new/notifications/figures');
      if (data.success) {
        store.dispatch('platform/setActiveNotifications', {...this.$ActiveNotifications, ...data.figures})
      }
    },
    getEmptyIndex() {
      let index = Math.floor(Math.random() * 20);
      if (this.showData[index]) {
        index = this.getEmptyIndex();
      }
      return index;
    }
  }
}
</script>

<style scoped>

.container {
  position: fixed;
  bottom: 60px;
  right: 0;
  max-width: 650px;
  z-index: 4;
}

</style>
